export enum OrderResultsTableColumnEnum {
    SAMPLE_NAME = 1,
    ORDER_NAME = 3,
    PRIMER_NAME = 4,
    REACTION_STATUS = 5,
    QC_LEVEL,
    LENGTH,
    QV20_PLUS,
    RESULTED,
    RETEST_STATUS,
    DOWNLOAD,
}

export const orderResultsTableColumnText: Record<OrderResultsTableColumnEnum, string> = {
    [OrderResultsTableColumnEnum.SAMPLE_NAME]: 'order.results.table.column.sample',
    [OrderResultsTableColumnEnum.ORDER_NAME]: 'order.results.table.column.orderName',
    [OrderResultsTableColumnEnum.PRIMER_NAME]: 'order.results.table.column.primer',
    [OrderResultsTableColumnEnum.REACTION_STATUS]: 'order.results.table.column.reactionStatus',
    [OrderResultsTableColumnEnum.QC_LEVEL]: 'order.results.table.column.qcLevel',
    [OrderResultsTableColumnEnum.LENGTH]: 'order.results.table.column.length',
    [OrderResultsTableColumnEnum.QV20_PLUS]: 'order.results.table.column.qv20Plus',
    [OrderResultsTableColumnEnum.RESULTED]: 'order.results.table.column.resulted',
    [OrderResultsTableColumnEnum.RETEST_STATUS]: 'order.results.table.column.retestStatus',
    [OrderResultsTableColumnEnum.DOWNLOAD]: 'order.results.table.column.download',
};
